module.exports = __webpack_public_path__ + "img/tools_paytrend_minwage.1f736b55.png";